// build: cache-bust v2 (new bundle hash to bypass stale CDN cache)
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Bundle build tag — also forces a new content hash to bypass stale CDN cache.
window.__ISP_BUILD__ = '2026-09-05-cachebust-2';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
